










import {
    Component,
    Prop,
    Vue,
    Watch,
} from 'vue-property-decorator'

@Component<PageToolbar>({})
export default class PageToolbar extends Vue {

  public title: string
  private readonly pageTitles: any = {
    'activity-synthesis': 'Consulter mon activité',
    'search-activity': 'Consulter mon activité',
    'search-flow': 'Rechercher un flux',
    'search-fundings': 'Financements non ventilés',
    'search-orders': 'Commandes non financées',
  }
  constructor() {
    super()
    this.title = ''
  }

  public mounted() {
    if (this.$route && this.$route.name) {
      this.title = this.pageTitles[this.$route.name] || ''
    }
  }

  @Watch('$route')
  public onRouteChanged(newRoute: any) {
    this.title = this.pageTitles[newRoute.name] || ''
  }
}
